export const css = {
    oneaction: '_2f5UIHSP',
    ' _key': 'certwise-theme/certwise/quiz-widgets/singlestep'
};
export default css;
